<div class="query-bar" [class.query-bar-disabled]="!filterEnabled">
  <i class="fa-solid fa-magnifying-glass query-bar-icon" aria-hidden="true"></i>
  <div
    class="query-chips"
    role="group"
    [attr.aria-label]="'common.label.activeFilters' | translate"
  >
    @for (chip of chips; track $index; let i = $index) {
      <span
        class="query-chip"
        [class.query-chip-locked]="chip.locked"
        [class.query-chip-invalid]="!!chip.reason"
        [class.query-chip-marked]="markedIndex === i"
      >
        <button
          type="button"
          class="query-chip-body"
          [disabled]="!filterEnabled"
          [title]="
            chip.reason
              ? (chip.reason | translate)
              : ('filter.action.editChip' | translate)
          "
          (mousedown)="$event.preventDefault()"
          (click)="edit(i)"
        >
          @if (chip.locked) {
            <i
              class="fa-solid fa-lock query-chip-lock"
              [title]="'filter.label.definition' | translate"
              aria-hidden="true"
            ></i>
          }
          @if (chip.reason) {
            <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
            <span
              class="query-chip-value"
              [attr.aria-label]="chip.value + ': ' + (chip.reason | translate)"
              >{{ chip.value }}</span
            >
          } @else {
            <span class="query-chip-label">{{ chip.label | translate }}:</span>
            <span class="query-chip-value">{{
              chip.condition?.field === 'business_id'
                ? ('filter.value.companies' | translate: { count: chip.value })
                : chip.value
            }}</span>
          }
        </button>
        <button
          type="button"
          class="query-chip-remove"
          [disabled]="!filterEnabled"
          [title]="'common.action.removeFilter' | translate"
          [attr.aria-label]="
            ('common.action.removeFilter' | translate) +
            ': ' +
            (chip.reason ? chip.value : (chip.label | translate))
          "
          (mousedown)="$event.preventDefault()"
          (click)="remove(i)"
        >
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </span>
    }
    <input
      #input
      type="text"
      class="query-input"
      role="combobox"
      autocomplete="off"
      spellcheck="false"
      aria-autocomplete="list"
      [attr.aria-expanded]="open && suggestions.length > 0"
      [attr.aria-controls]="id + '-listbox'"
      [attr.aria-activedescendant]="activeId"
      [attr.aria-label]="'filter.label.query' | translate"
      [placeholder]="
        dirty
          ? ('filter.label.pressEnter' | translate)
          : chips.length
            ? ''
            : ('filter.label.placeholder' | translate)
      "
      [disabled]="!filterEnabled"
      [value]="text"
      (input)="onInput(input.value)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
    />
  </div>
  @if (chips.length) {
    <button
      type="button"
      class="query-reset"
      [disabled]="!filterEnabled"
      [title]="'common.action.resetFilters' | translate"
      [attr.aria-label]="'common.action.resetFilters' | translate"
      (click)="reset()"
    >
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  }
  <button
    type="button"
    class="query-search"
    [class.query-search-pending]="dirty"
    [disabled]="!filterEnabled"
    [title]="
      (dirty ? 'filter.action.searchPending' : 'filter.action.search')
        | translate
    "
    (mousedown)="$event.preventDefault()"
    [attr.aria-label]="'filter.action.search' | translate"
    (click)="search()"
  >
    <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
    <span>{{ 'filter.action.search' | translate }}</span>
  </button>
  <button
    type="button"
    class="query-builder-toggle"
    [attr.aria-controls]="builderId"
    [attr.aria-expanded]="builderOpen"
    [title]="'filter.action.builder' | translate"
    (click)="builderToggle.emit()"
  >
    <i class="fa-solid fa-sliders" aria-hidden="true"></i>
    <span>{{ 'common.label.filter' | translate }}</span>
    <i
      class="fa-solid"
      [class.fa-chevron-up]="builderOpen"
      [class.fa-chevron-down]="!builderOpen"
      aria-hidden="true"
    ></i>
  </button>
  @if (open && suggestions.length) {
    <ul
      class="query-suggestions"
      role="listbox"
      [id]="id + '-listbox'"
      [attr.aria-label]="'filter.label.suggestions' | translate"
    >
      @for (suggestion of suggestions; track $index; let i = $index) {
        <li
          role="option"
          tabindex="-1"
          class="query-suggestion"
          [id]="id + '-option-' + i"
          [class.query-suggestion-active]="i === activeIndex"
          [attr.aria-selected]="i === activeIndex"
          (mousedown)="$event.preventDefault()"
          (click)="pick(suggestion)"
          (keydown.enter)="pick(suggestion)"
        >
          @switch (suggestion.kind) {
            @case ('preset') {
              <i class="fa-solid fa-bolt" aria-hidden="true"></i>
              <span>{{ suggestion.label | translate }}</span>
              <code>{{ suggestion.query }}</code>
            }
            @case ('recent') {
              <i class="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>
              <span>{{ suggestion.search.label }}</span>
            }
            @case ('insert') {
              <i class="fa-solid fa-filter" aria-hidden="true"></i>
              <span>{{ 'filter.field.' + suggestion.field | translate }}</span>
              <code>{{ suggestion.value }}</code>
            }
            @case ('commit') {
              <i class="fa-solid fa-plus" aria-hidden="true"></i>
              <span
                >{{ 'filter.field.' + suggestion.field | translate }}
                {{
                  (suggestion.field === 'name'
                    ? 'filter.label.contains'
                    : 'filter.label.is'
                  ) | translate
                }}</span
              >
              <strong>{{ suggestion.value }}</strong>
            }
          }
        </li>
      }
    </ul>
  }
</div>
<ng-content></ng-content>
